import { Flex, Text } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks/useGravityDevice";

export interface TextSectionProps {
  title: React.ReactNode;
  description: React.ReactNode;
}

export const TextSection = ({ title, description }: TextSectionProps) => {
  const { isMobile, deviceText } = useGravityDevice();

  return (
    <Flex
      direction={isMobile ? "column" : "row"}
      justifyContent={isMobile ? "center" : "space-between"}
      gap={6}
    >
      <Text variant={deviceText.display}>{title}</Text>

      <Flex direction={"column"} gap={6}>
        <Text
          variant={deviceText.subheader}
          color="hint"
          style={{ maxWidth: 400 }}
        >
          {description}
        </Text>
      </Flex>
    </Flex>
  );
};
